import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useAdminClaimsApi } from "../../http/claims/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteClaimDialogProps = {
  claimId: string;
  carId: string;
  onClose: (success: boolean) => void;
};

const DeleteClaimDialog: FC<DeleteClaimDialogProps> = ({ claimId, onClose, carId }) => {
  const i18n = useI18n();
  const claimsApi = useAdminClaimsApi();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useContext(NotificationDispatch);

  return (
    <ModalDialog
      onClose={() => onClose(false)}
      title={i18n.t.claims.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: () => onClose(false),
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            claimsApi
              .deleteAdminClaim(claimId, carId)
              .then(() => onClose(true))
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.claims.questions.delete}
    </ModalDialog>
  );
};

export default DeleteClaimDialog;
